import { render, staticRenderFns } from "./LookTenderNotice.vue?vue&type=template&id=5ed2ede8&scoped=true"
import script from "./LookTenderNotice.vue?vue&type=script&lang=js"
export * from "./LookTenderNotice.vue?vue&type=script&lang=js"
import style0 from "./LookTenderNotice.vue?vue&type=style&index=0&id=5ed2ede8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2ede8",
  null
  
)

export default component.exports